var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{attrs:{"d":"M21,8H3V6H21M9,13H21V11H9M9,18H21V16H9"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }